// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__39BJR","select":"styles_select__20pYC"};